import z from 'zod'

const emailRegex =
  /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)*$/

export const GetEmailSchema = z
  .string()
  .email({ message: 'Invalid email address' }) // Optional: Keep for basic check, but override pattern
  .refine(val => emailRegex.test(val), {
    message: 'Please enter a valid email address',
  })
